import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import readm from '../assets/img/readm.png';
import { StaticQuery, graphql } from 'gatsby';

import '../assets/sass/main.scss';
const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            welcome {
              title
            }
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.welcome.title}
          meta={[
            { name: 'description', content: 'Best Learn To Read app for kids - English reading tutor app' },
            {
              name: 'keywords',
              content:
                'learn to read app for kids, english reading app, english learn to read app, speech recognition, reading educational app',
            },
            {
              property: `og:image`,
              content: readm,
            },
          ]}
        >
          <html lang="en" />
          <link
            href="//fonts.googleapis.com/css?family=Raleway:200&display=swap"
            rel="stylesheet"
          />
        </Helmet>
        <div>{children}</div>
      </>
    )}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
